import { inject, injectable, interfaces } from 'inversify';
import { TimePeriod } from '../../../../design/selects/timePeriodSelector/S_TimePeriodSelector';
import { ACDLError } from '../../../models/error.model';
import { SortingDirection } from '../../../models/sortingDirection.model';
import { IMainApiService, IPagedResult } from '../../../services/api.service';
import { IApiService } from '../../../services/api.service.base';
import { ITeamMember } from '../models/TeamMember';

interface IGetTeamMembersRequest {
  workspaceId: string;
  timePeriod: TimePeriod;
  pageNumber: number;
  pageSize: number;
  orderBy: string;
  orderType: SortingDirection;
}

export interface IGetTeamMembersService {
  getTeamMembersAsync: (request: IGetTeamMembersRequest) => Promise<IPagedResult<ITeamMember>>;
}

export namespace IGetTeamMembersService {
  export const $: interfaces.ServiceIdentifier<IGetTeamMembersService> = Symbol('GET_WORKSPACE_TEAM_MEMBERS_SERVICE');
}

@injectable()
export class GetTeamMembersService implements IGetTeamMembersService {
  constructor(@inject(IMainApiService.$) private readonly apiService: IApiService) {}

  public async getTeamMembersAsync(request: IGetTeamMembersRequest): Promise<IPagedResult<ITeamMember>> {
    const result = await this.apiService.getAsync<IPagedResult<ITeamMember>>('/Workspace/getTeamMembers', { params: request });

    if (result instanceof ACDLError) {
      throw result;
    }

    return result;
  }
}
